import './App.css';
import Pagina from "./Pagina/Pagina";
import {Grid} from "@mui/material";
import '@fontsource/kanit/400.css'
import '@fontsource/kanit/500.css'
import '@fontsource/kanit/600.css'
import '@fontsource/kanit/700.css'
import '@fontsource/kanit/800.css'
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {where} from "firebase/firestore";
import {useFuncionesCarritoLateral} from "./Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";
import {obtenerObjLocal} from "./Servicios/Local/obtenerObjLocal";

export const contexApp = createContext()

function App() {
    const {data: categorias, actualizarDataLocal: actCategorias} = useObtenerDataActualizada({clave: 'categorias'})
    const {data: productosHome, actualizarDataLocal: actProductosHome} = useObtenerDataActualizada({clave: 'productos'})
    const {data: anuncio, actualizarDataLocal: actAnuncio} = useObtenerDataActualizada({clave: 'anuncio'})
    const {setProductos} = useFuncionesCarritoLateral()

    const valoresProvider = {
        categorias,
        productosHome,
        anuncio
    }

    const {Provider} = contexApp;

    useEffect(() => {
        obtenerFechaAct('categorias').then((dox) => {
            let w = []
            actCategorias({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('productos').then((dox) => {
            let w = [where('enHome', '==', true)]
            actProductosHome({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('anuncio').then((dox) => {
            let w = []
            actAnuncio({fecha: dox, wheres: w}).then()
        })

        let carritoLocal = obtenerObjLocal({key: 'carrito'})
        if (carritoLocal) {

            setProductos(carritoLocal)
        }

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <h1 style={{display: 'none'}}>Recuerdos de Nariño</h1>
            <h2 style={{display: 'none'}}>Recuerdos de Pasto</h2>
            <h2 style={{display: 'none'}}>Artesanias de Nariño</h2>
            <h2 style={{display: 'none'}}>Artesanias Pasto</h2>
            <h2 style={{display: 'none'}}>Tienda de recuerdo Pasto</h2>
            <h2 style={{display: 'none'}}>Tienda de artesanias Pasto</h2>
            <h2 style={{display: 'none'}}>Tienda de artesanias Coombianas</h2>

            <Provider value={valoresProvider}>

                <Pagina/>


            </Provider>

        </Grid>
    );
}

export default App;
